import React, { useState } from 'react'

import PropTypes from 'prop-types'

import { Visibility, VisibilityOff } from '@mui/icons-material'
import { IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material'
import { UserDialogFormHelperText } from '../../styles/components/UserDialogStyle'

const PasswordInput = ({
  handleChange,
  name,
  value,
  label = 'Password',
  errorMessage = '',
  autocomplete = true,
  // eslint-disable-next-line no-unused-vars
  ...props
}) => {
  const [isVisiblePassword, setIsVisiblePassword] = useState(false)

  const handlePasswordVisibility = () => {
    setIsVisiblePassword(!isVisiblePassword)
  }

  return (
    <>
      <InputLabel htmlFor="outlined-adornment-password">{label}</InputLabel>
      <OutlinedInput
        label={label}
        variant="outlined"
        onChange={handleChange}
        value={value}
        name={name}
        type={isVisiblePassword ? 'text' : 'password'}
        error={errorMessage !== ''}
        inputProps={{
          autoComplete: autocomplete ? 'password' : 'new-password',
        }}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="passwordVisibility" onClick={handlePasswordVisibility} edge="end">
              {isVisiblePassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
      {errorMessage.password !== '' && (
        <UserDialogFormHelperText aria-label="passwordValidation">{errorMessage}</UserDialogFormHelperText>
      )}
    </>
  )
}

PasswordInput.propTypes = {
  handleChange: PropTypes.func,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  parentStyle: PropTypes.object,
  autocomplete: PropTypes.bool,
}

export default PasswordInput
